module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t('mission.creator.title')))])]), _vm._v(" "), _c('div', [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.submitMissionCreate($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.title'),
      "state": _vm.missionCreateTitleState,
      "feedback": _vm.missionCreateTitleFeedback,
      "description": _vm.$t('mission.title.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": "",
      "formatter": _vm.missionCreateTitleFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.missionCreateTitle),
      callback: function($$v) {
        _vm.missionCreateTitle = $$v
      },
      expression: "missionCreateTitle"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slug'),
      "state": _vm.missionCreateSlugState,
      "feedback": _vm.missionCreateSlugFeedback,
      "description": _vm.$t('mission.slug.description')
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": _vm.missionCreateSlugAvailable
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": "",
      "formatter": _vm.missionCreateSlugFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.missionCreateSlug),
      callback: function($$v) {
        _vm.missionCreateSlug = $$v
      },
      expression: "missionCreateSlug"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.description'),
      "state": _vm.missionCreateDescriptionState,
      "feedback": _vm.missionCreateDescriptionFeedback,
      "description": _vm.$t('mission.description.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "textarea": "",
      "required": ""
    },
    model: {
      value: (_vm.missionCreateDescription),
      callback: function($$v) {
        _vm.missionCreateDescription = $$v
      },
      expression: "missionCreateDescription"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.detailedDescription'),
      "state": _vm.missionCreateDetailedDescriptionState,
      "feedback": _vm.missionCreateDetailedDescriptionFeedback,
      "description": _vm.$t('mission.detailedDescription.description')
    }
  }, [_c('quill-editor', {
    ref: "missionCreateDetailedDescriptionEditor",
    attrs: {
      "options": _vm.descriptionEditorOptions,
      "required": ""
    },
    model: {
      value: (_vm.missionCreateDetailedDescription),
      callback: function($$v) {
        _vm.missionCreateDetailedDescription = $$v
      },
      expression: "missionCreateDetailedDescription"
    }
  }), _vm._v(" "), _c('editor-explanation')], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.collapsedDescription.optional'),
      "state": "success",
      "description": _vm.$t('mission.collapsedDescription.description')
    }
  }, [_c('quill-editor', {
    ref: "missionCreatecollapsedDescriptionEditor",
    attrs: {
      "options": _vm.descriptionEditorOptions
    },
    model: {
      value: (_vm.missionCreatecollapsedDescription),
      callback: function($$v) {
        _vm.missionCreatecollapsedDescription = $$v
      },
      expression: "missionCreatecollapsedDescription"
    }
  }), _vm._v(" "), _c('editor-explanation')], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slottingTime'),
      "state": _vm.missionCreateSlottingTimeState,
      "feedback": _vm.missionCreateSlottingTimeFeedback,
      "description": _vm.$t('mission.slottingTime.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "YYYY-MM-DD HH:mm",
      "formatter": _vm.missionCreateTimeFormatter,
      "lazy-formatter": ""
    },
    on: {
      "blur": _vm.missionCreateSlottingTimeBlur
    },
    model: {
      value: (_vm.missionCreateSlottingTime),
      callback: function($$v) {
        _vm.missionCreateSlottingTime = $$v
      },
      expression: "missionCreateSlottingTime"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.startTime'),
      "state": _vm.missionCreateStartTimeState,
      "feedback": _vm.missionCreateStartTimeFeedback,
      "description": _vm.$t('mission.startTime.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "YYYY-MM-DD HH:mm",
      "formatter": _vm.missionCreateTimeFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.missionCreateStartTime),
      callback: function($$v) {
        _vm.missionCreateStartTime = $$v
      },
      expression: "missionCreateStartTime"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.endTime'),
      "state": _vm.missionCreateEndTimeState,
      "feedback": _vm.missionCreateEndTimeFeedback,
      "description": _vm.$t('mission.endTime.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "YYYY-MM-DD HH:mm",
      "formatter": _vm.missionCreateTimeFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.missionCreateEndTime),
      callback: function($$v) {
        _vm.missionCreateEndTime = $$v
      },
      expression: "missionCreateEndTime"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.briefingTime'),
      "state": _vm.missionCreateBriefingTimeState,
      "feedback": _vm.missionCreateBriefingTimeFeedback,
      "description": _vm.$t('mission.briefingTime.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "YYYY-MM-DD HH:mm",
      "formatter": _vm.missionCreateTimeFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.missionCreateBriefingTime),
      callback: function($$v) {
        _vm.missionCreateBriefingTime = $$v
      },
      expression: "missionCreateBriefingTime"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.techSupport.optional'),
      "state": _vm.missionCreateTechSupportState,
      "feedback": _vm.missionCreateTechSupportFeedback,
      "description": _vm.$t('mission.techSupport.description')
    }
  }, [_c('quill-editor', {
    ref: "missionCreateTechSupportEditor",
    attrs: {
      "options": _vm.editorOptions
    },
    model: {
      value: (_vm.missionCreateTechSupport),
      callback: function($$v) {
        _vm.missionCreateTechSupport = $$v
      },
      expression: "missionCreateTechSupport"
    }
  }), _vm._v(" "), _c('editor-explanation')], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.rules.optional'),
      "state": _vm.missionCreateRulesState,
      "feedback": _vm.missionCreateRulesFeedback,
      "description": _vm.$t('mission.rules.description')
    }
  }, [_c('quill-editor', {
    ref: "missionCreateRulesEditor",
    attrs: {
      "options": _vm.editorOptions
    },
    model: {
      value: (_vm.missionCreateRules),
      callback: function($$v) {
        _vm.missionCreateRules = $$v
      },
      expression: "missionCreateRules"
    }
  }), _vm._v(" "), _c('editor-explanation')], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.gameServer.hostname.optional'),
      "state": _vm.missionCreateGameServerHostnameState,
      "feedback": _vm.missionCreateGameServerHostnameFeedback,
      "description": _vm.$t('mission.gameServer.hostname.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionCreateGameServerHostname),
      callback: function($$v) {
        _vm.missionCreateGameServerHostname = $$v
      },
      expression: "missionCreateGameServerHostname"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.voiceComms.hostname.optional'),
      "state": _vm.missionCreateVoiceCommsHostnameState,
      "feedback": _vm.missionCreateVoiceCommsHostnameFeedback,
      "description": _vm.$t('mission.voiceComms.hostname.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionCreateVoiceCommsHostname),
      callback: function($$v) {
        _vm.missionCreateVoiceCommsHostname = $$v
      },
      expression: "missionCreateVoiceCommsHostname"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.gameServer.port.optional'),
      "state": _vm.missionCreateGameServerPortState,
      "feedback": _vm.missionCreateGameServerPortFeedback,
      "description": _vm.$t('mission.gameServer.port.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "max": "65535"
    },
    model: {
      value: (_vm.missionCreateGameServerPort),
      callback: function($$v) {
        _vm.missionCreateGameServerPort = $$v
      },
      expression: "missionCreateGameServerPort"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.voiceComms.port.optional'),
      "state": _vm.missionCreateVoiceCommsPortState,
      "feedback": _vm.missionCreateVoiceCommsPortFeedback,
      "description": _vm.$t('mission.voiceComms.port.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "max": "65535"
    },
    model: {
      value: (_vm.missionCreateVoiceCommsPort),
      callback: function($$v) {
        _vm.missionCreateVoiceCommsPort = $$v
      },
      expression: "missionCreateVoiceCommsPort"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.gameServer.name.optional'),
      "state": "success",
      "description": _vm.$t('mission.gameServer.name.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionCreateGameServerName),
      callback: function($$v) {
        _vm.missionCreateGameServerName = $$v
      },
      expression: "missionCreateGameServerName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.voiceComms.name.optional'),
      "state": "success",
      "description": _vm.$t('mission.voiceComms.name.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionCreateVoiceCommsName),
      callback: function($$v) {
        _vm.missionCreateVoiceCommsName = $$v
      },
      expression: "missionCreateVoiceCommsName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.gameServer.password.optional'),
      "state": "success",
      "description": _vm.$t('mission.gameServer.password.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionCreateGameServerPassword),
      callback: function($$v) {
        _vm.missionCreateGameServerPassword = $$v
      },
      expression: "missionCreateGameServerPassword"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.voiceComms.password.optional'),
      "state": "success",
      "description": _vm.$t('mission.voiceComms.password.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionCreateVoiceCommsPassword),
      callback: function($$v) {
        _vm.missionCreateVoiceCommsPassword = $$v
      },
      expression: "missionCreateVoiceCommsPassword"
    }
  })], 1)], 1)]), _vm._v(" "), ((_vm.communityGameServers && _vm.communityGameServers.length > 0) || (_vm.communityVoiceComms && _vm.communityVoiceComms.length > 0)) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [(_vm.communityGameServers && _vm.communityGameServers.length > 0) ? _c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('community.gameServers'),
      "state": "success",
      "description": _vm.$t('community.gameServers.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionCreateCommunityGameServers
    },
    model: {
      value: (_vm.missionCreateCommunityGameServersSelected),
      callback: function($$v) {
        _vm.missionCreateCommunityGameServersSelected = $$v
      },
      expression: "missionCreateCommunityGameServersSelected"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [(_vm.communityVoiceComms && _vm.communityVoiceComms.length > 0) ? _c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('community.voiceComms'),
      "state": "success",
      "description": _vm.$t('community.voiceComms.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionCreateCommunityVoiceComms
    },
    model: {
      value: (_vm.missionCreateCommunityVoiceCommsSelected),
      callback: function($$v) {
        _vm.missionCreateCommunityVoiceCommsSelected = $$v
      },
      expression: "missionCreateCommunityVoiceCommsSelected"
    }
  })], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.user.community) ? _c('div', {
    staticClass: "col text-center"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.creator.addToCommunity'),
      "state": _vm.missionCreateAddToCommunityState,
      "feedback": _vm.missionCreateAddToCommunityFeedback,
      "description": _vm.missionCreateAddToCommunityDescription
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionCreateAddToCommunity),
      callback: function($$v) {
        _vm.missionCreateAddToCommunity = $$v
      },
      expression: "missionCreateAddToCommunity"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col text-center"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slotsAutoAssignable'),
      "state": "success",
      "description": _vm.$t('mission.slotsAutoAssignable.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionCreateSlotsAutoAssignable),
      callback: function($$v) {
        _vm.missionCreateSlotsAutoAssignable = $$v
      },
      expression: "missionCreateSlotsAutoAssignable"
    }
  })], 1)], 1)]), _vm._v(" "), _c('span', {
    staticClass: "text-success",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400",
      "line-height": "1.5"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.requiredDLCs')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionCreateRequiredDLCs.aow),
      callback: function($$v) {
        _vm.missionCreateRequiredDLCs.aow = $$v
      },
      expression: "missionCreateRequiredDLCs.aow"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/aow.png",
      "width": "16px",
      "alt": "Art of War"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.aow')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionCreateRequiredDLCs.apex),
      callback: function($$v) {
        _vm.missionCreateRequiredDLCs.apex = $$v
      },
      expression: "missionCreateRequiredDLCs.apex"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/apex.png",
      "width": "16px",
      "alt": "Apex"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.apex')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionCreateRequiredDLCs.contact),
      callback: function($$v) {
        _vm.missionCreateRequiredDLCs.contact = $$v
      },
      expression: "missionCreateRequiredDLCs.contact"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/contact.png",
      "width": "16px",
      "alt": "Contact"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.contact')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionCreateRequiredDLCs.csla),
      callback: function($$v) {
        _vm.missionCreateRequiredDLCs.csla = $$v
      },
      expression: "missionCreateRequiredDLCs.csla"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/csla.png",
      "width": "16px",
      "alt": "CSLA Iron Curtain"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.csla')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionCreateRequiredDLCs.gm),
      callback: function($$v) {
        _vm.missionCreateRequiredDLCs.gm = $$v
      },
      expression: "missionCreateRequiredDLCs.gm"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/gm.png",
      "width": "16px",
      "alt": "Global Mobilization"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.gm')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionCreateRequiredDLCs.helicopters),
      callback: function($$v) {
        _vm.missionCreateRequiredDLCs.helicopters = $$v
      },
      expression: "missionCreateRequiredDLCs.helicopters"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/helicopters.png",
      "width": "16px",
      "alt": "Helicopters"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.helicopters')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionCreateRequiredDLCs.jets),
      callback: function($$v) {
        _vm.missionCreateRequiredDLCs.jets = $$v
      },
      expression: "missionCreateRequiredDLCs.jets"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/jets.png",
      "width": "16px",
      "alt": "Jets"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.jets')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionCreateRequiredDLCs.karts),
      callback: function($$v) {
        _vm.missionCreateRequiredDLCs.karts = $$v
      },
      expression: "missionCreateRequiredDLCs.karts"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/karts.png",
      "width": "16px",
      "alt": "Karts"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.karts')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionCreateRequiredDLCs.lawsofwar),
      callback: function($$v) {
        _vm.missionCreateRequiredDLCs.lawsofwar = $$v
      },
      expression: "missionCreateRequiredDLCs.lawsofwar"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/laws-of-war.png",
      "width": "16px",
      "alt": "Laws of War"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.laws-of-war')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionCreateRequiredDLCs.marksmen),
      callback: function($$v) {
        _vm.missionCreateRequiredDLCs.marksmen = $$v
      },
      expression: "missionCreateRequiredDLCs.marksmen"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/marksmen.png",
      "width": "16px",
      "alt": "Marksmen"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.marksmen')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionCreateRequiredDLCs.tacops),
      callback: function($$v) {
        _vm.missionCreateRequiredDLCs.tacops = $$v
      },
      expression: "missionCreateRequiredDLCs.tacops"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/tac-ops.png",
      "width": "16px",
      "alt": "Tac-Ops"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.tac-ops')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionCreateRequiredDLCs.tanks),
      callback: function($$v) {
        _vm.missionCreateRequiredDLCs.tanks = $$v
      },
      expression: "missionCreateRequiredDLCs.tanks"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/tanks.png",
      "width": "16px",
      "alt": "Tanks"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.tanks')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionCreateRequiredDLCs.vn),
      callback: function($$v) {
        _vm.missionCreateRequiredDLCs.vn = $$v
      },
      expression: "missionCreateRequiredDLCs.vn"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/vn.png",
      "width": "16px",
      "alt": "S.O.G. Prairie Fire"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.vn')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.visibility'),
      "state": _vm.missionCreateVisibilityState,
      "feedback": _vm.missionCreateVisibilityFeedback,
      "description": _vm.$t('mission.visibility.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionCreateVisibilityOptions,
      "required": ""
    },
    model: {
      value: (_vm.missionCreateVisibility),
      callback: function($$v) {
        _vm.missionCreateVisibility = $$v
      },
      expression: "missionCreateVisibility"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submitMissionCreate
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.create.mission')) + "\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ce955a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MissionCreator.vue
// module id = 507
// module chunks = 0